import React, { useEffect, useState } from "react";
import { Table, Card } from "antd";
import { doGet } from '../../../../API/apis'
import Notification from "../../../../components/Notification/Notification";

const OutOfStockMedicines = () => {
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(false)
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
      const handleResize = () => {
        setWindowWidth(window.innerWidth);
      };
      
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    const columns = [
        {
          key: 1,
          title: "#",
          render: (_, record, index) => index + 1,
          align: "center",
          width: 50,
          fixed: 'left',
        },
        {
          key: "sku",
          title: "SKU",
          align: 'center',
          dataIndex: "sku",
          responsive: ['md'],
          width: 120,
        },
        {
          key: 2,
          align: 'center',
          title: "Brand Name",
          dataIndex: "medicine_name",
          width: 150,
          fixed: windowWidth < 576 ? 'left' : null,
        },
        {
          key: 3,
          align: 'center',
          title: "Generic Name",
          dataIndex: "generic_name",
          responsive: ['sm'],
          width: 150,
        },
        {
          key: 4,
          align: 'center',
          title: "Category",
          dataIndex: "category",
          responsive: ['md'],
          width: 120,
        },
        {
          key: 5,
          align: 'center',
          title: "Strength",
          dataIndex: 'strength',
          responsive: ['lg'],
          width: 100,
        },
        {
          key: 6,
          align: 'center',
          title: "Manufacturer",
          dataIndex: 'manufacturer',
          responsive: ['lg'],
          width: 150,
        },
        {
          key: 7,
          title: 'Location',
          align: 'center',
          dataIndex: 'location',
          responsive: ['md'],
          width: 120,
        },
    ];

    const getOutofStockProducts = async () => {
        setLoading(true);
        try {
          const response = await doGet(`/inventory/out-of-stock/`);
          if (response.status === 200) {
            setData(response?.data);
          }
        } catch (error) {
          Notification.error("Something Went Wrong");
        } finally {
          setLoading(false);
        }
    };

    useEffect(() => {
        getOutofStockProducts();
    }, []);

    return (
        <Card className="shadow-sm" loading={loading}>
            <h1 className="font-bold text-lg mb-2">Out of Stock Inventory</h1>
            <div className="overflow-x-auto w-full" style={{ overflowX: 'auto' }}>
                <Table 
                    size="small" 
                    loading={loading} 
                    columns={columns} 
                    dataSource={data} 
                    pagination={
                        windowWidth < 768 ? 
                        { pageSize: 5, size: "small" } : 
                        windowWidth < 1200 ?
                        { pageSize: 8, size: "small" } :
                        { pageSize: 10 }
                    }
                    scroll={{ x: 'calc(800px + 50%)', y: 240 }}
                    className="min-w-full"
                />
            </div>
        </Card>
    );
};

export default OutOfStockMedicines;
